module.exports = __webpack_public_path__ + "img/3.264b0cdc.svg";